import React from 'react';
import { Navbar } from '../components/Navbar';
import { StickyFooter } from '../components/StickyFooter';
import { ServiceHero } from '../components/ServiceHero';
import { ServiceContactForm } from '../components/ServiceContactForm';
import { CheckCircleIcon } from 'lucide-react';
export function InHomeNursing() {
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-1025">
      <Navbar data-id="element-1026" />
      <main className="flex-1" data-id="element-1027">
        <ServiceHero badge="Care Solutions" title="In-Home Nursing" subtitle="Professional nursing care delivered in the comfort of your home." imageUrl="https://images.unsplash.com/photo-1581594693702-fbdc51b2763b?w=1600&auto=format&fit=crop" data-id="element-1028" />

        <div className="max-w-4xl mx-auto px-4 py-16 lg:py-24" data-id="element-1029">
          <div className="prose prose-lg max-w-none text-text-muted leading-relaxed space-y-6" data-id="element-1030">
            <p data-id="element-1031">
              Our In-Home Nursing services provide professional, compassionate
              care in the comfort of your own home. Our Registered Nurses (RNs)
              and Registered Practical Nurses (RPNs) are trained to deliver a
              wide range of clinical services, from wound care and IV therapy to
              medication administration and chronic disease management.
            </p>
            <p data-id="element-1032">
              Whether you need post-surgical recovery care, ongoing support for
              a chronic condition, or specialized care for a loved one, our
              in-home nursing team is here to help. Every care plan is
              nurse-supervised, ensuring the highest standards of clinical
              quality and patient safety.
            </p>
          </div>

          <div className="mt-12 bg-gray-50 rounded-2xl p-8 border border-gray-100" data-id="element-1033">
            <h3 className="text-2xl font-bold text-text-dark mb-6" data-id="element-1034">
              In-Home Nursing Benefits
            </h3>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1035">
              {['Post-surgical recovery care at home', 'Professional wound care & IV therapy', 'Chronic disease monitoring & management', 'Medication administration & education', 'Nurse-supervised personalized care plans', 'Reduced hospital readmission rates'].map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-1036">
                  <CheckCircleIcon className="w-6 h-6 text-accent-teal flex-shrink-0 mt-0.5" data-id="element-1037" />
                  <span className="text-text-dark font-medium" data-id="element-1038">{feature}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <ServiceContactForm serviceName="In-Home Nursing" data-id="element-1039" />
      </main>
      <StickyFooter data-id="element-1040" />
    </div>;
}